import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "@playbookai/api-clients";
import { kpiApi } from "../api/live-client.js";
import type { CreateKpiInput, ManagedKpi } from "../api/types.js";
import { kpiKeys } from "./kpiQueryKeys.js";

/**
 * Create a configured KPI from a Type (`POST /v1/kpis`) and refresh the list.
 * Invalidates every list variant so the new draft appears under the active
 * filters.
 */
export function useCreateKpi() {
  const config = useApiClient();
  const qc = useQueryClient();
  return useMutation<ManagedKpi, Error, CreateKpiInput>({
    mutationFn: (input) => kpiApi.createKpi(config, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: kpiKeys.lists() });
    },
  });
}
